import { DocumentTypeCat } from '@ps/platform-message-framework/common/DocumentTypeCat';
import { Sites } from '@ps/platform-message-framework/common/Sites';
import { select } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import { required } from '@ps/web-shared-validators';
import React from 'react';
import { useSelector } from 'react-redux';

import { Country } from '@swf/core/enums';

import RMFDropDown from '../../../RMFDropDown/RMFDropDown';

import {
  TXTCLI_DriverXs_License,
  TXTCLI_National_Identity_Card,
  TXTCLI_Other__choice,
  TXTCLI_Passport,
  TXTWCL_Document_type,
  TXTWCL_Please_choose_document_type,
  TXTWCL_Residence_Card
} from './DocumentTypeField.messages.json';
import { wrapper } from './DocumentTypeField.scss';

export const docTypeField = 'docType';

interface Props {
  country?: string;
  citizenship?: string;
  className?: string;
}

const getOptions = (
  siteId: number,
  country: string | undefined,
  citizenship: string | undefined
) => {
  switch (siteId) {
    case Sites.POR:
      return [
        {
          text: <Translation {...TXTCLI_DriverXs_License} />,
          value: DocumentTypeCat.DRIVERS_LICENSE
        },
        { text: <Translation {...TXTCLI_Passport} />, value: DocumentTypeCat.PASSPORT },
        { text: <Translation {...TXTCLI_Other__choice} />, value: DocumentTypeCat.OTHER }
      ];

    case Sites.SPA:
      if (country !== Country.Spain && citizenship !== Country.Spain) {
        return [
          { text: <Translation {...TXTCLI_Passport} />, value: DocumentTypeCat.PASSPORT },
          { text: <Translation {...TXTCLI_Other__choice} />, value: DocumentTypeCat.OTHER }
        ];
      }
      if (citizenship !== Country.Spain) {
        return [
          {
            text: <Translation {...TXTWCL_Residence_Card} />,
            value: DocumentTypeCat.NATIONAL_IDENTITY_CARD
          }
        ];
      }
      return [
        {
          text: <Translation {...TXTCLI_National_Identity_Card} />,
          value: DocumentTypeCat.NATIONAL_IDENTITY_CARD
        }
      ];

    default:
      return [
        {
          text: <Translation {...TXTCLI_National_Identity_Card} />,
          value: DocumentTypeCat.NATIONAL_IDENTITY_CARD
        },
        {
          text: <Translation {...TXTCLI_DriverXs_License} />,
          value: DocumentTypeCat.DRIVERS_LICENSE
        },
        { text: <Translation {...TXTCLI_Passport} />, value: DocumentTypeCat.PASSPORT }
      ];
  }
};

const DocumentTypeField: React.FC<Props> = ({ country, citizenship }) => {
  const siteId = useSelector(select.cms.getSiteId);
  const isSpain = siteId === Sites.SPA;

  const disabled = isSpain && (country === Country.Spain || citizenship === Country.Spain);
  const options = getOptions(siteId, country, citizenship);

  return (
    <RMFDropDown
      id={docTypeField}
      label={TXTWCL_Document_type}
      options={options}
      validators={[required(TXTWCL_Please_choose_document_type)]}
      className={wrapper}
      disabled={disabled}
    />
  );
};

export default DocumentTypeField;
